import type { ReactNode } from 'react';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

// The bits of src/components/ui/form.tsx the onboarding forms actually render, without
// the react-hook-form context that file exists for (PORTING.md U2 — Inertia owns the
// form state now). Same elements, same classes, so the DOM matches the Next page.

export function FormItem({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <div data-slot="form-item" className={cn('grid gap-2', className)}>
      {children}
    </div>
  );
}

export function FormLabel({
  htmlFor,
  error,
  children,
}: {
  htmlFor?: string;
  error?: boolean;
  children: ReactNode;
}) {
  return (
    <Label
      data-slot="form-label"
      data-error={!!error}
      htmlFor={htmlFor}
      className="data-[error=true]:text-destructive"
    >
      {children}
    </Label>
  );
}

export function FormDescription({ children }: { children: ReactNode }) {
  return (
    <p data-slot="form-description" className="text-muted-foreground text-sm">
      {children}
    </p>
  );
}

export function FormMessage({ children }: { children?: string }) {
  if (!children) return null;

  return (
    <p data-slot="form-message" className="text-destructive text-sm">
      {children}
    </p>
  );
}

// The red / green boxes the Next forms rendered from `serverState.globalError` and
// `serverState.message`. The global error arrives as the Inertia error keyed `base`.
export function GlobalError({ children }: { children?: string }) {
  if (!children) return null;

  return (
    <div className="rounded-md border border-red-200 bg-red-50 p-4">
      <p className="text-red-600 text-sm">{children}</p>
    </div>
  );
}
